import React from 'react';
import { DropDownBox, DropDownBoxComponentSpacing, TextBox } from '@apply/components';
import { SUFFIX_OPTIONS } from '../constants/options';
import { asInput } from './inputValue';

export interface PersonName {
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
}

interface PersonNameFieldsProps {
    idPrefix: string;
    value: PersonName;
    onChange: (patch: Partial<PersonName>) => void;
    requiredFields?: boolean;
    readOnly?: boolean;
}

export const PersonNameFields: React.FC<PersonNameFieldsProps> = ({
    idPrefix,
    value,
    onChange,
    requiredFields = false,
    readOnly = false,
}) => {
    const update = <K extends keyof PersonName>(key: K, fieldValue: PersonName[K]) =>
        onChange({ [key]: fieldValue } as Partial<PersonName>);

    return (
        <>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                <div style={{ flex: '1 1 220px', minWidth: '220px' }}>
                    <TextBox
                        id={`${idPrefix}FirstName`}
                        value={asInput(value.firstName)}
                        onChange={(v) => update('firstName', v)}
                        label='First name'
                        required={requiredFields}
                        readOnly={readOnly}
                        maxLength={100}
                    />
                </div>
                <div style={{ flex: '1 1 160px', minWidth: '160px' }}>
                    <TextBox
                        id={`${idPrefix}MiddleName`}
                        value={asInput(value.middleName)}
                        onChange={(v) => update('middleName', v)}
                        label='Middle'
                        readOnly={readOnly}
                        maxLength={50}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                <div style={{ flex: '1 1 220px', minWidth: '220px' }}>
                    <TextBox
                        id={`${idPrefix}LastName`}
                        value={asInput(value.lastName)}
                        onChange={(v) => update('lastName', v)}
                        label='Last name'
                        required={requiredFields}
                        readOnly={readOnly}
                        maxLength={100}
                    />
                </div>
                <div style={{ flex: '1 1 160px', minWidth: '160px' }}>
                    <DropDownBox
                        id={`${idPrefix}Suffix`}
                        value={asInput(value.suffix)}
                        onChange={(v) => update('suffix', v)}
                        label='Suffix'
                        dataSource={SUFFIX_OPTIONS}
                        valueExpr='value'
                        displayExpr='display'
                        readOnly={readOnly}
                        componentSpacing={DropDownBoxComponentSpacing.SmallSpacing}
                    />
                </div>
            </div>
        </>
    );
};
